import { useState, useEffect, useCallback, useRef } from 'react';
import { Bars } from 'react-loader-spinner';
import axios from 'axios';
import { Divider } from '@material-ui/core';
import Fancybox from '../Fancybox/Fancybox.component';
import { Grid, Box, Button, Tab, Drawer } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
//import '@google/model-viewer/dist/model-viewer'
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import {Scrollbar} from 'smooth-scrollbar-react';
import { TabPanel, TabContext, TabList } from '@material-ui/lab';
import { Pannellum } from 'pannellum-react';

import 'react-tabs/style/react-tabs.css';
import { round } from 'lodash';
import { translations } from '../../i18n/i18n';

const useStyles = makeStyles((theme) => ({
	drawer: {
		position: 'absolute',
		width: 520,
	},
	drawerPaper: {
		boxSizing: 'content-box',
		width: 520,
	},
	drawerHeader: {
		...theme.mixins.toolbar,
		display: 'flex',
		alignItems: 'center',
		marginTop: '15px',
		minHeight: '48px !important',
		padding: theme.spacing(0, 1),
		justifyContent: 'space-between',
	},
	overviewImage: {
		height: '300px',
		objectFit: 'cover',
		width: '100%',
	},
	overviewTable: {
		marginTop: 10,
	},
	tab: {
		flexBasis: 1,
		flexGrow: 1,
		minWidth: 70,
		textTransform: 'none',
	},
	gridImage: {
		height: '100%',
		maxHeight: '150px',
		objectFit: 'cover',
		width: '100%',
	},
	coordinateMr:{
		marginRight: 8,
	},
	panoramaContainer: {
		display: 'none',
		height: '100%',
		width: '100%',
	}
}));

function ConvertDDToDMS(D, lng) {
	const data = {
		dir: D < 0 ? (lng ? "W" : "S") : lng ? "E" : "N",
		deg: 0 | (D < 0 ? (D = -D) : D),
		min: round((((D += 1e-9) % 1) * 60) * 1000) / 1000,
	};

	return `${data.deg}° ${data.min}'`;
}

const PlaceDetails = ({ placeId, isOpen, placeTypes, photoTypes, modelTypes, onCloseRequest }) => {
	const [tab, setTab] = useState('0');
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState(null);
	const [loadedPans, setLoadedPans] = useState([]);
	const panRefs = useRef({});
	const classes = useStyles();
	const history = useHistory();
	const theme = useTheme();

	useEffect(() => {
		if(!placeId) return;

		setLoading(true);

		axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/map/getPlaceData/${placeId}`, { headers: { 'Accept-Language': translations.getLanguage(), 'X-Requested-With': 'XMLHttpRequest' } }).then(response => {
			setData(response.data);
			setTab('0');
			setLoading(false);
		}).catch(err => {

		});
	}, [placeId]);

	//Find the first photo of the highest ordered photo type
	const overviewPhotoType = data && photoTypes.find(photoType => data.photos.find(photo => photo.photo_type_id == photoType.id) !== undefined);
	const overviewPhoto = data && overviewPhotoType !== undefined ? data.photos.find(photo => photo.photo_type_id == overviewPhotoType.id) : false;

	//Group media
	const reconstructionPhotoTypeId = (photoTypes.find(photoType => photoType.name.toLowerCase().includes('rekonstrukció') || photoType.name.toLowerCase().includes('reconstruction')) || {}).id;
	const reconstructionVideos = data && data.videos.filter(v => v.reconstruction);
	const reconstructionPhotos = data && data.photos.filter(p => p.photo_type_id == reconstructionPhotoTypeId);

	const panoramaPhotoTypeId = (photoTypes.find(photoType => photoType.name.toLowerCase().includes('panoráma') || photoType.name.toLowerCase().includes('panorama')) || {}).id;
	const panoramaPhotos = data && data.photos.filter(p => p.photo_type_id == panoramaPhotoTypeId);

	const restVideos = data && data.videos.filter(v => !v.reconstruction);
	const restPhotos = data && data.photos.filter(p => p.photo_type_id != reconstructionPhotoTypeId && p.photo_type_id != panoramaPhotoTypeId);

	const onPanSlideLoad = useCallback((fancybox, slide) => {
		setLoadedPans(current => [...current, slide.photoid]);

		let viewerRef = panRefs.current[slide.photoid];
		if(viewerRef) {
			//Force resize to prevent bugs due to modal animation
			viewerRef.panorama.resize();
		}
	}, []);

	return <Drawer
			className={classes.drawer+' place-drawer'}
			variant="persistent"
			anchor="right"
			open={!!placeId}
			classes={{
				paper: classes.drawerPaper+' place-drawer-paper',
			}}
		>
			<div className={classes.drawerHeader}>
				<IconButton onClick={onCloseRequest}>
					<ChevronRightIcon />
				</IconButton>
				<Typography variant="h6" color="secondary">{placeId != undefined && !loading && data && data.name}</Typography>
				<Box width="48px" />
			</div>

		{loading && <Box display="flex" alignItems="center" justifyContent="center" flexGrow={1}>
			<Bars color='#254e91' />
		</Box>}

		{placeId != undefined && !loading && data && <TabContext value={tab}>
			<TabList onChange={(e, v) => setTab(v)}>
				<Tab label={translations.components.placeDetails.overview} value="0" classes={{ root: classes.tab }} />
				{data.guide && data.guide.length > 0 ? 
					<Tab label={translations.components.placeDetails.guide} value="1" classes={{ root: classes.tab }} /> : <div></div>}
				{reconstructionVideos.length > 0 || reconstructionPhotos.length > 0 || panoramaPhotos.length > 0 ? 
					<Tab label={translations.components.placeDetails.reconstruction} value="2" classes={{ root: classes.tab }} /> : <div></div>}
				{restVideos.length > 0 || restPhotos.length > 0 ? 
					<Tab label={translations.components.placeDetails.media} value="3" classes={{ root: classes.tab }} /> : <div></div>}
			</TabList>
		
			<Scrollbar plugins={{overscroll: { effect: 'glow', } }} >
				<TabPanel value="0">
					{overviewPhoto && <Fancybox options={{ infinite: false }}>
						<a
							data-fancybox={overviewPhoto.photo_type_id}
							data-thumb={overviewPhoto.thumb_url}
							href={overviewPhoto.hq_url}
							data-caption={overviewPhoto.caption}
							>
							<img src={overviewPhoto.thumb_url} alt={overviewPhoto.caption ?? data.name} className={classes.overviewImage} />
						</a>
					</Fancybox>}
					<Table className={classes.overviewTable}>
						<TableBody>
							<TableRow>
								<TableCell component="th" scope="row">{translations.components.placeDetails.placeType}</TableCell>
								<TableCell align="right">
									{data.place_type_ids.map(placeTypeId => {
										const placeTypeData = placeTypes.find(item => item.id == placeTypeId);
										if(placeTypeData === undefined) return null;

										return <div key={placeTypeId}>{placeTypeData.name}</div>;
									})}
								</TableCell>
							</TableRow>
							{data.alt_name && <TableRow>
								<TableCell component="th" scope="row">{translations.components.placeDetails.altNames}</TableCell>
								<TableCell align="right">{data.alt_name}</TableCell>
							</TableRow>}
							{data.location && <TableRow>
								<TableCell component="th" scope="row">{translations.components.placeDetails.location}</TableCell>
								<TableCell align="right">{data.location}</TableCell>
							</TableRow>}
							<TableRow>
								<TableCell component="th" scope="row">{translations.components.placeDetails.coordinates}</TableCell>
								<TableCell align="right">
									<Box display="flex" justifyContent="space-between">
										<div className={classes.coordinateMr}>{ConvertDDToDMS(data.coordinate_y, true)}</div>
										<div>{ConvertDDToDMS(data.coordinate_x, true)}</div>
									</Box>
									<Box display="flex" justifyContent="space-between">
										<div className={classes.coordinateMr}>({data.coordinate_y})</div>
										<div>({data.coordinate_x})</div>
									</Box>
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
					
					<Box width="100%" textAlign="center" mt={4}>
						<Button startIcon={<OpenInNewIcon />} onClick={() => window.open(window.location, '_blank')}>{translations.components.placeDetails.openInNewWindow}</Button>
					</Box>
				</TabPanel>
				{data.guide && data.guide.length > 0 && <TabPanel value="1">
					<div dangerouslySetInnerHTML={{ __html: data.guide }}></div>
				</TabPanel>}
				{(reconstructionVideos.length > 0 || reconstructionPhotos.length > 0 || panoramaPhotos.length > 0) && <TabPanel value="2">
					<Fancybox options={{ infinite: false }}>
						{reconstructionVideos.length > 0 && <div>
							<Typography variant="subtitle1" gutterBottom>{translations.global.video}</Typography>
							<Grid container spacing={2}>
								{reconstructionVideos.map(video => {
									return <Grid item xs={4} key={video.id}>
										<a
											data-fancybox="video"
											data-thumb={video.thumb_url}
											href={(video.source === 'youtube' ? 'https://www.youtube.com/watch?v=' : 'https://vimeo.com/')+video.video_id}
											data-caption={video.caption}
											>
											<img src={video.thumb_url} alt={video.caption ?? data.name} className={classes.gridImage} />
										</a>
									</Grid>;
								})}
							</Grid>

							{(panoramaPhotos.length > 0 || reconstructionPhotos.length > 0) && <Box mt={4} mb={3}>
								<Divider />
							</Box>}
						</div>}
					</Fancybox>

					<Fancybox delegate="#pangroup [data-fancybox]" options={{ infinite: false, preload: 0, on: { done: onPanSlideLoad }, Carousel: { Panzoom: { touch: false } } }}>
						{panoramaPhotos.length > 0 && <div id="pangroup">
							<Typography variant="subtitle1" gutterBottom>{translations.global.panoramaPhoto}</Typography>
							<Grid container spacing={2}>
								{panoramaPhotos.map((photo, i) => {
									return <Grid item xs={4} key={photo.id}>
										<div id={`panview_${photo.id}`} className={classes.panoramaContainer}>
											<Pannellum
												image={loadedPans.includes(photo.id) ? photo.hq_url : ''}
												preview={photo.thumb_url}
												height="100%"
												ref={(r) => panRefs.current[photo.id] = r}
												autoLoad
												maxHfov={100}
											/>
										</div>
										<a
											data-fancybox={panoramaPhotoTypeId}
											data-thumb={photo.thumb_url}
											data-photoid={photo.id}
											href={`#panview_${photo.id}`}
											data-caption={photo.caption}
											>
											<img src={photo.thumb_url} alt={photo.caption ?? data.name} className={classes.gridImage} />
										</a>
									</Grid>;
								})}
							</Grid>

							{reconstructionPhotos.length > 0 && <Box mt={4} mb={3}>
								<Divider />
							</Box>}
						</div>}
					</Fancybox>

					{reconstructionPhotos.length > 0 && <div>
						<Typography variant="subtitle1" gutterBottom>{translations.global.photo}</Typography>
						<Grid container spacing={2}>
							{reconstructionPhotos.map(photo => <Grid item xs={4} key={photo.id}>
								<a
									data-fancybox={reconstructionPhotoTypeId}
									data-thumb={photo.thumb_url}
									href={photo.hq_url}
									data-caption={photo.caption}
									>
									<img src={photo.thumb_url} alt={photo.caption ?? data.name} className={classes.gridImage} />
								</a>
							</Grid>)}
						</Grid>
					</div>}
				</TabPanel>}
				{(restVideos.length > 0 || restPhotos.length > 0) && <TabPanel value="3">
					<Fancybox options={{ infinite: false }}>
						{restVideos.length > 0 && <div>
							<Typography variant="subtitle1" gutterBottom>{translations.global.video}</Typography>
							<Grid container spacing={2}>
								{restVideos.map(video => {
									return <Grid item xs={4} key={video.id}>
										<a
											data-fancybox="video"
											data-thumb={video.thumb_url}
											href={(video.source === 'youtube' ? 'https://www.youtube.com/watch?v=' : 'https://vimeo.com/')+video.video_id}
											data-caption={video.caption}
											>
											<img src={video.thumb_url} alt={video.caption ?? data.name} className={classes.gridImage} />
										</a>
									</Grid>;
								})}
							</Grid>

							{restPhotos.length > 0 && <Box mt={4} mb={3}>
								<Divider />
							</Box>}
						</div>}

						{photoTypes.filter(photoType => restPhotos.find(photo => photo.photo_type_id == photoType.id) !== undefined).map((photoType, index, array) => <div key={photoType.id}>
							<Typography variant="subtitle1" gutterBottom>{photoType.name}</Typography>
							<Grid container spacing={2}>
								{restPhotos.filter(photo => photo.photo_type_id == photoType.id).map(photo => <Grid item xs={4} key={photo.id}>
									<a
										data-fancybox={photoType.id}
										data-thumb={photo.thumb_url}
										href={photo.hq_url}
										data-caption={photo.caption}
										>
										<img src={photo.thumb_url} alt={photo.caption ?? data.name} className={classes.gridImage} />
									</a>
								</Grid>)}
							</Grid>

							{index < array.length-1 && <Box mt={4} mb={3}>
								<Divider />
							</Box>}
						</div>)}
					</Fancybox>
				</TabPanel>}
				{/*data.models.length > 0 && <TabPanel value="4">
					<Fancybox
						delegate="[data-fancyboxformodel]"
						options={{
							dragToClose: false,
							preload: 0,
							click: false,
						}}
					>
						{modelTypes.filter(modelType => data.models.find(model => model.model_type_id == modelType.id) !== undefined).map((modelType, index, array) => <div key={modelType.id}>
							<Typography variant="subtitle1" gutterBottom>{modelType.name}</Typography>
							<Grid container spacing={2}>
								{data.models.filter(model => model.model_type_id == modelType.id).map(model => <Grid item xs={4} key={model.id}>
									<div id={`model${model.id}`} style={{display: 'none'}}>
										<model-viewer
											src={model.model_url}
											poster={model.preview_url}
											alt={model.caption}
											loading="lazy"
											shadow-intensity='1'
											camera-controls
											auto-rotate
											ar
											style={{height: '70vh', width: '60vw'}}>
										</model-viewer>
									</div>
									<a
										href={`#model${model.id}`}
										data-fancyboxformodel="model"
										data-type="inline"
										data-thumb={model.preview_url}
										data-caption={model.caption}
									>
										<img src={model.preview_url} alt={model.caption ?? data.name} className={classes.gridImage} />
									</a>
								</Grid>)}
							</Grid>

							{index < array.length-1 && <Box mt={4} mb={3}>
								<Divider />
							</Box>}
						</div>)}
					</Fancybox>
				</TabPanel>*/}
			</Scrollbar>
		</TabContext>}
	</Drawer>;
};

export default PlaceDetails;